// import * as React from "react";
// import { Navigate } from "react-router-dom";

// export type ProtectedRouteProps = {
//   authenticationPath: string;
//   outlet: React.ReactNode;
// };

// export default function ProtectedRoute({
//   authenticationPath,
//   outlet,
// }: ProtectedRouteProps) {
//   const accessToken = localStorage.getItem("access_token");

//   if (accessToken) {
//     return <>{outlet}</>; // Wrap in fragment if outlet can be a string or array
//   } else {
//     return <Navigate to={authenticationPath} replace />;
//   }
// }


import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ authenticationPath, outlet }: any) => {
  const isAuth = localStorage.getItem("access_token"); // or use Redux/AuthContext
  
  if (!isAuth) {
    return <Navigate to={authenticationPath} replace />;
  } 

  return outlet;
};

export default ProtectedRoute;
